module.exports = __webpack_public_path__ + "static/media/20.27484437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/20.jpg
// module id = 591
// module chunks = 0